import { useSelector } from "react-redux";

export default function useUserState() {
  //Getting the data from session storage
  const sessionStore = JSON.parse(sessionStorage.getItem("userState"));

  //Extract the userState to Redux Glabal State
  const userState = useSelector((state) => {
    if (state.currentUser.user) {
      return state.currentUser;
    } else if (sessionStore) {
      return sessionStore;
    }
  });

  // Extract the time_zone from the user object if it exists
  const timeZone = userState?.user?.time_zone || "America/Costa_Rica";

  return [userState, timeZone];
}
